<template>
    <div id="app">
        <navbar />
        <firstSection />
        <secondSection />
        <projekt />
        <omMig />
        <myFooter />
    </div>
</template>

<script>
import navbar from './components/header/navbar'
import firstSection from './components/sections/firstSection'
import secondSection from './components/sections/secondSection'
import projekt from './components/sections/projekt'
import myFooter from './components/sections/footer'
import omMig from './components/sections/omMig'

export default {
    components: {
        navbar,
        firstSection,
        secondSection,
        projekt,
        omMig,
        myFooter
    }
}
</script>

<style>

:root {
    --my-color: #00C851;
}

.my-color {
    color: #00C851;
}

html {
    scroll-behavior: smooth;
}

.min-font {
    font-family: 'PT Serif' ; ;
}

h1 {
    font-family: 'PT Serif' ;
    letter-spacing: 2px;
}

.rubrik {
    letter-spacing: 2px;
}

p {
    font-family: 'Open Sans';
    letter-spacing: 1px;
}

.animated {
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
}

.my-hr-color {
    background-color: #00C851;
    height: 0.3rem;
    border-radius: 20px;
    box-shadow: 0px 0px 24px 8px rgba(0, 200, 80, 0.562);    
}

.my-hr-size {
    border-radius: 50%;
    width: 23%;
    height: 2.5px;
    margin-top: -0.3rem;
    margin-bottom: 5rem;
}

::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: #1B242F; 
    box-shadow: inset 0 0 6px rgb(7, 6, 6); 
}

::-webkit-scrollbar-thumb {
    background: rgb(2, 131, 54); 
    -webkit-border-radius: 50px;
    border-radius: 50px;
}

::-webkit-scrollbar-thumb:hover{
    background: #00C851; 
}


</style>
